<template>
  <div>
    <van-row :gutter="10">
      <van-col :span="24">
        <div :class="{'form-box-tag':true,'active':isactive}" @click="swap()">{{name}}</div>
      </van-col>
    </van-row>
    <van-popup v-model="showPicker" position="bottom">
      <van-nav-bar
        title
        left-text="取消"
        right-text="确认"
        @click-left="showPicker=false"
        @click-right="onEnter"
      />
      <van-row>
        <van-col span="8">
          <van-picker :columns="start" ref="onStart" />
        </van-col>
        <van-col span="8">
          <van-picker :columns="middle" />
        </van-col>
        <van-col span="8">
          <van-picker :columns="end" ref="onEnd" />
        </van-col>
      </van-row>
    </van-popup>
  </div>
</template>

<script>
import { Picker, Row, Col, Tag, Popup, NavBar } from "vant";

export default {
  components: {
    [Picker.name]: Picker,
    [Row.name]: Row,
    [Col.name]: Col,
    [Tag.name]: Tag,
    [Popup.name]: Popup,
    [NavBar.name]: NavBar
  },

  data() {
    return {
      isactive: false,
      showPicker: false,
      middle: [{ text: "至", disabled: true }],
      name: ""
    };
  },
  props: {
    title: {
      type: String,
      default: "请选择"
    },
    start: Array,
    end: Array
  },
  mounted() {
    this.name = this.title;
  },

  methods: {
    swap(index, value) {
      this.showPicker = true;
    },

    onEnter() {
      this.showPicker = false;
      this.isactive = true;
      var arr = this.$refs.onStart
        .getValues()
        .concat(this.$refs.onEnd.getValues());
      this.name = arr.join(" - ");
      this.$emit("change", arr);
    }
  }
};
</script>

<style scoped>
.form-box-tag {
  background-color: #f8f8f8;
  line-height: 32px;
  text-align: center;
  color: #555;
  border-radius: 4px;
  cursor: pointer;
}
.form-box-tag.active {
  background-color: #feefe9;
  color: #f56229;
}
</style>>



